<template>
  <div>
    <router-link class="d-block mb-2" to="/admin/products"
      >← 商品一覧に戻る</router-link
    >
    <h2 class="headline mb-3">商品編集</h2>
    <v-row>
      <product-form :product="product" />
      <product-image-form
        :product-images="productImages"
        @update-images="updateImages"
      />
    </v-row>
    <v-divider />
    <v-row>
      <product-link-form-list :product="product" />
    </v-row>
  </div>
</template>

<script>
import ProductForm from '@/components/commons/products/ProductForm'
import ProductImageForm from '@/components/commons/products/ProductImageForm'
import ProductLinkFormList from '@/components/commons/products/ProductLinkFormList'

export default {
  components: {
    ProductLinkFormList,
    ProductImageForm,
    ProductForm
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    productImages: {
      type: Array,
      required: true
    }
  },
  methods: {
    updateImages (images) {
      this.$emit('update:product-images', images)
    }
  }
}
</script>
